import { Component, OnInit, inject, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';
import { ApiService } from '../../core/api.service';
import { DocumentExtraction } from '../../core/models';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-extractions',
  standalone: true,
  imports: [CommonModule, RouterLink],
  templateUrl: './extractions.component.html',
  styleUrl: './extractions.component.scss',
})
export class ExtractionsComponent implements OnInit {
  private api = inject(ApiService);
  items = signal<DocumentExtraction[]>([]);
  selected = signal<DocumentExtraction | null>(null);
  message = signal('');

  ngOnInit(): void {
    this.reload();
  }

  reload(): void {
    this.api.get<DocumentExtraction[]>('/api/extractions').subscribe((items) => {
      this.items.set(items);
      const sel = this.selected();
      if (sel) {
        const updated = items.find((i) => i.id === sel.id);
        this.selected.set(updated || null);
      }
    });
  }

  open(item: DocumentExtraction): void {
    this.api.get<DocumentExtraction>(`/api/extractions/${item.id}`).subscribe((e) => {
      this.selected.set(e);
    });
  }

  approve(): void {
    const e = this.selected();
    if (!e) return;
    this.api.post<DocumentExtraction>(`/api/extractions/${e.id}/approve`, {}).subscribe((res) => {
      this.selected.set(res);
      this.message.set('Piani approvati e task generati.');
      this.reload();
    });
  }

  reject(): void {
    const e = this.selected();
    if (!e) return;
    this.api.post<DocumentExtraction>(`/api/extractions/${e.id}/reject`, {}).subscribe((res) => {
      this.selected.set(res);
      this.message.set('Estrazione rifiutata.');
      this.reload();
    });
  }

  mediaUrl(url?: string | null): string {
    if (!url) return '';
    if (url.startsWith('http')) return url;
    return `${environment.apiUrl}${url}`;
  }

  authSrc(url?: string | null): string {
    const base = this.mediaUrl(url);
    if (!base) return '';
    const token = localStorage.getItem('token');
    const sep = base.includes('?') ? '&' : '?';
    return token ? `${base}${sep}token=${encodeURIComponent(token)}` : base;
  }
}
